"use strict";

var getTagManagerScriptPath = require('./tag-manager');

var _require = require('./trigger-analytics'),
    triggerAnalytics = _require.triggerAnalytics,
    triggerAnalyticsSync = _require.triggerAnalyticsSync;

module.exports = {
  getTagManagerScriptPath: getTagManagerScriptPath,
  triggerAnalytics: triggerAnalytics,
  triggerAnalyticsSync: triggerAnalyticsSync
};